export default {
  "fontElementMap": "_86BTT",
  "imageContainer": "_9ibYI",
  "expandButton": "GTrbr",
  "expandIcon": "ogyKu",
  "pointer": "k2VLT",
  "imageWrapper": "UonQy",
  "imageRatio": "c9aiU",
  "image": "Epnnj",
  "imageOverlay": "_4KmZJ",
  "imagePreload": "-okoM",
  "imageHighres": "_5wQZS",
  "onlyHighRes": "HqteR",
  "image_loading": "siEYk"
};